import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { UpdateStatusService } from "../services/updateStatus.service";

@Injectable()
export class BlockRequestsInterceptor implements HttpInterceptor {
    constructor(private updateStatusService: UpdateStatusService) {}

    // left as 'any' because interceptors are meant to be generic
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.updateStatusService.getOutOfSyncValue()) {
            // Cancel request
            console.warn("Blocked Http request due to Arcus out-of-sync status:", req.url);
            return EMPTY;
        }

        return next.handle(req);
    }
}
